<template>
  <div class="auth-wrapper auth-v2">
    <!-- <div>
      <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" size="invisible" :sitekey="recaptchaKey" />
    </div> -->
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <b-img :src="logoUrl" /> -->
        <!--  <vuexy-logo /> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 background-login"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid imgUrl />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5" v-if="!displayTwoFactorAuth">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="logo-login">
            <span class="logo-cma-pwd"></span>
          </div>
          <!-- <span class="logo-login"><vuexy-logo /></span> -->
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
          </b-card-title>
          <b-card-text class="mb-2">
          </b-card-text>

          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    tabindex="1"
                    ref="email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="Digite o e-mail"
                    v-on:keyup.13="focusPassword"
                    autofocus
                  />
                  <small class="text-danger" v-if="showValidationErrors">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t("LOGIN.Password") }}</label>
                  <b-link :to="{ name: 'forgot-password' }">
                    <small>{{ $t("LOGIN.ForgotPass") }}</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Senha"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      tabindex="2"
                      v-model="password"
                      ref="loginPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger" v-if="showValidationErrors">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  {{ $t("LOGIN.Remember") }}
                </b-form-checkbox>
              </b-form-group>

              <b-button
                type="submit"
                tabindex="3"
                variant="primary"
                block
                @click="newLogin"
              >
                {{ $t("LOGIN.Title") }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
      <!-- Two Factor Authentication -->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5" v-if="displayTwoFactorAuth">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="logo-login">
            <span class="logo-cma-pwd"></span>
          </div>
          <feather-icon icon="XIcon" class="cursor-pointer" style="position: absolute; right: 10px;" @click="displayTwoFactorAuth=!displayTwoFactorAuth"/>
          <b-card-title title-tag="h2" class="font-weight-bold mt-1">
            {{ $t("LOGIN.Two_Factor_Auth_Title") }}
          </b-card-title>
          <b-card-text class="mb-1 font-size-small">
            {{ $t("LOGIN.Two_Factor_Auth_Desc") }}
            <p style="font-size: smaller">Não recebeu email? <a style="text-decoration: underline;" @click.stop="sendTwoFactorAuth">Clique aqui</a> para reenviar o código</p>
          </b-card-text>
          <!-- <b-card-text class="font-size-small">
            Não recebeu email? <a>Clique aqui</a> para reenviar o código
          </b-card-text> -->

          <validation-observer ref="tokenValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <b-form-group :label="$t('LOGIN.Two_Factor_Auth_Code')" label-for="login-token">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('LOGIN.Two_Factor_Auth_Code')"
                  rules="required"
                >
                  <b-form-input
                    id="login-token"
                    tabindex="1"
                    ref="token"
                    v-model="twoFactorAuthenticationToken"
                    :state="errors.length > 0 ? false : null"
                    name="login-token"
                    :placeholder="$t('LOGIN.Two_Factor_Auth_Code_Placeholder')"
                    autofocus
                  />
                  <small class="text-danger" v-if="showValidationErrors">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                tabindex="3"
                variant="primary"
                block
                @click="validateTwoFactorAuthToken"
              >
                {{ $t("LOGIN.Title") }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Two Factor Authentication -->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
// import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import authService from "@/providers/authService";
import AppConstants from "@/appConstants";
import { $themeConfig } from "@themeConfig";
import UAParser from "ua-parser-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { ENUM_LOCALE_LIST } from '@/helpers/locale-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
// import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    // VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    // VueRecaptcha,
  },
  mixins: [togglePasswordVisibility],
  mounted() {
    this.$refs["email"].focus();
  },
  data() {
    return {
      status: "",
      password: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/newspapper.jpg"),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      showValidationErrors: false,
      twoFactorAuthenticationToken: "",
      displayTwoFactorAuth: false
    };
  },
  computed: {
    recaptchaKey() {
      return '6LegSvAgAAAAAGCKUtfMBKOxdPMDyDaVhwar1B7w';
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === AppConstants.THEME_DARK) {
        return $themeConfig.app.appLogoImageBlack;
      }
      return $themeConfig.app.appLogoImageWhite;
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === AppConstants.THEME_DARK) {
        //eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/newspapper.jpg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    onVerifyRecaptcha(response) {
      console.log('Verify: ' + response);
      this.sendTwoFactorAuth();
    },
    onExpiredRecaptcha() {
      console.log('Expired');
    },
    validateTwoFactorAuthToken() {
      this.showValidationErrors = true;
      this.$refs.tokenValidation.validate().then((success) => {
        if (success) {
          this.showValidationErrors = false;
          authService.validateTwoFactorAuthToken({email: this.userEmail, token: this.twoFactorAuthenticationToken}, new URLSearchParams())
          .then(res => {
            this.onSuccessLogin(res);
          }).catch(err => {
            console.log(err);
          });
        }
      })
    },
    focusPassword() {
      this.$refs.loginPassword.focus();
    },
    newLogin() {
      this.showValidationErrors = true;
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.showValidationErrors = false;
          // this.$refs.invisibleRecaptcha.execute();
          this.sendTwoFactorAuth();
        }
      });
    },
    sendTwoFactorAuth() {
      authService.loginTwoFactorAuth({email: this.userEmail, password: this.password}, new URLSearchParams())
        .then((res) => {
          if (res.isAdmin || !res.auth2F) {
            this.onSuccessLogin(res.data);
          } else {
            messagesNotifyHelper.successNotify('Autenticação', `Código enviado para email ${this.userEmail}`);
            this.displayTwoFactorAuth = true;
          }
        });
    },
    validationForm() {
      this.showValidationErrors = true;
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: 'Form Submitted',
          //     icon: 'EditIcon',
          //     variant: 'success',
          //   },
          // });
          const fpPromise = FingerprintJS.load();
          fpPromise
            .then((fp) => fp.get())
            .then((fp) => {
              // This is the visitor identifier:
              const parser = new UAParser();
              const form = {
                email: this.userEmail,
                password: this.password,
                userAgent: parser.getResult(),
                visitorId: fp.visitorId
              };
              authService.login(form, new URLSearchParams()).then((res) => {
                this.successLogin(res);
              });
            });
        }
      });
    },
    onSuccessLogin(res) {
      authService.successLogin(res);
      // update user theme
      if (res.theme) {
        if (res.theme == AppConstants.THEME_DARK) {
          this.$store.dispatch("auth/updateTheme", AppConstants.THEME_DARK);
        } else {
          this.$store.dispatch("auth/updateTheme", AppConstants.THEME_LIGHT);
        }
      }

      if (res.locale) {
        this.$i18n.locale = ENUM_LOCALE_LIST.find(item => item.id == res.locale).locale;
        this.$store.dispatch("auth/updateLocale", res.locale);
      }

      console.log("route query: ", this.$route.query);
      const routeQuery = Object.keys(this.$route.query).filter(
        (q) => q != "to"
      );
      const routePath = {
        path: this.$route.query.to
          ? this.$route.query.to
          : AppConstants.NAVIGATION_PAGE_MANAGE_NEWS,
        query: this.$route.query.to
          ? {}
          : { event_status: AppConstants.EVENT_STATUS.PUBLISHED },
      };

      if (routeQuery) {
        routePath.query = {};
        routeQuery.forEach((key) => {
          routePath.query[key] = this.$route.query[key];
        });
      }

      this.$router.push(routePath);
    },
  },
  beforeDestroy() {
    this.$forceUpdate();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
